import { Dashboard } from "@mui/icons-material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Box, Card, CardContent, CardHeader, Grid2, IconButton, MenuItem, Select, Tab, Tabs } from "@mui/material";

import { useState } from "react";
import Text from "../../../genericComponents/Text";
import { useSideScreen } from "../../../Layout/backoffice";
import DateFilter from "../../../sidescreen/dateFilter";

const MultiChartCard = ({ graphs, height, title, start, setStart, end, setEnd }) => {
        
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };    
    const { openSideScreen } = useSideScreen();
   
    return <Card>
        <CardHeader sx={{ borderBottom: "1px solid #ddd" }}
            title={<Grid2 container spacing={1} sx={{display:"flex",alignItems:"center"}}><Dashboard fontSize="large" /><Text variant="h2" text={title} /></Grid2>}
            action={<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                
                <IconButton sx={{borderRadius:8,pl:1,pr:1,height:"36px"}} onClick={() => openSideScreen(DateFilter, {
                    data: { start, end },
                    notifyParent: ({ start, end }) => { setStart(start); setEnd(end) }
                })}>
                    <>
                    <Text sx={{ pr: 1 }} text={start.toLocaleString()} />                 -
                <Text sx={{ pl: 1, pr: 1 }} text={end.toLocaleString()} />
                <CalendarMonthIcon />
                </>
                    
                </IconButton>
                </div>                
            }
        />
        <CardContent sx={{ paddingBottom: 0 }}>
            <Grid2 container >
                <Grid2 size={12} sx={{display:{xs:"block",lg:"none"}}}>
                <Select onChange={e => setValue(e.target.value)} value={value} fullWidth>                    
                {graphs.map((x,i)=><MenuItem value={i} key={i}>{x.name}</MenuItem>)}                
                    </Select>
                    </Grid2>
                <Grid2 size={{md:3}} sx={{display:{xs:"none",lg:"block"},borderRight: "1px solid #ddd" }}>
                    <Tabs
                        selectionFollowsFocus
                        value={value}
                        onChange={handleChange}
                        orientation="vertical">
                        {graphs.map((x,i) => <Tab key={i} sx={{alignItems:"start"}} label={x.name} aria-label={x.name} />)}
                    </Tabs>
                </Grid2>
                <Grid2 sx={{height:height}} size={{xs:12,lg:9}}>
                    {graphs.map((x, i) => <Box key={i} hidden={value !== i}>{x.graph}</Box>)}
                </Grid2>
            </Grid2>
        </CardContent>        
    </Card>    
}
export default MultiChartCard;